export var SENTRY_RELEASE = "6c61208aba3fc1e105f50e67e3fe34b793d18403";
